export default __webpack_public_path__ + "static/media/cards-test.fa4cc479.png";